import styled from '@emotion/styled';

const StyledFromDiscount = styled.small(
  {
    lineHeight: '18px'
  },
  ({ theme }) => ({
    fontSize: theme.typography.fontSize.medium,
    color: theme.palette.colors.midnightBlue,
    fontWeight: theme.typography.fontWeightLight
  })
);

export default StyledFromDiscount;
